import type { ComponentReviewThread } from './component-review-thread.type.ts';
export interface ComponentReviewThreadExtension extends ComponentReviewThread {}
export class ComponentReviewThreadExtension {
  get isOpen() {
    return this.status === 'open';
  }

  get isResolved() {
    return this.status === 'resolved';
  }

  get commentCount() {
    return this.comments?.length ?? 0;
  }
}

const Registration = {
  kind: 'object',
  name: 'component-review-thread',
  features: ComponentReviewThreadExtension,
};
export default Registration;
